<template>
    <div id="attach">
        <v-card width="1500">
            <v-alert
                dense
                border="bottom"
                type="primary"
                icon="mdi-information"
            >
                ATTACHMENTS
            </v-alert>
            <v-card-text>
                <v-container>
                    <v-row> </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["detailcase"],
    data() {
        return {}
    },
}
</script>
